import clsx from 'clsx';
import { AText } from '@alf/uikit';
import { CURRENCY_CODE_TO_SYMBOL } from '@namespace/helpers';

export const WagerContent = ({
  wagerOptions,
  outputBetTotal,
  outputMaxTotal,
  currencyToSymbol,
  currency,
  isDisplayCurrencySymbol
}) => (
  <AText
    breed="B"
    size="s"
    color="po_txt_color_3"
    className={clsx([wagerOptions])}
  >
    {`(${outputBetTotal} / ${outputMaxTotal} ${
      currencyToSymbol || isDisplayCurrencySymbol
        ? CURRENCY_CODE_TO_SYMBOL[currency]
        : currency
    })`}
  </AText>
);
